// Labels for the entitlements status returned by getEntitlements() /
// the admin org list+detail endpoints — 'admin' (is_admin bypass) is
// never returned for an org-level status, so it's omitted here.
export const STATUS_LABEL = {
    paid: 'Pro (paid)',
    comped: 'Pro (complimentary)',
    trialing: 'Pro trial',
    free: 'Free searches',
};
